module.exports = __webpack_public_path__ + "static/media/trash-alt.762fa71b.svg";